import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
//import { Navigation } from "./Navigation";
import { AccountMenu } from "./Component/AccountMenu";
import "../node_modules/video-react/dist/video-react.css";
import { useUser } from "./Provider/UserProvider";
import "./Component/Asset.css";
import { useNavigate } from "react-router-dom";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import MeasurementDataTable from "./Component/MeasurementDataTable";
import { Grid } from "@mui/material";
import { OwnedGroupSelectBox2 } from "./Component/OwnedGroupSelectBox2";
import Modal from "./Component/Modal";
import { MeasurementStartDateSelectBox } from "./Component/MeasurementStartDateSelectBox";
import { API_DOMAIN_URL } from "./Common";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export function EditMeasurement() {
  const navigate = useNavigate();
  const { user } = useUser();
  const [ownedGroups, setOwnedGroups] = useState();
  const [targetGroup, setTargetGroup] = useState();
  const [groupMembers, setGroupMembers] = useState([]);
  const [membersLoading, setMembersLoading] = useState(false);
  const [targetMemberId, setTargetMemberId] = useState("all");
  const [targetPeriod, setTargetPeriod] = useState();

  const authCheck = () => {
    if (!user || !user.id || user.id == "error") {
      navigate("/SignIn");
      return false;
    }
    return true;
  };

  useEffect(() => {
    authCheck();
  }, []);

  useEffect(() => {
    if (user && user.id) {
      getOwnedGroups(user);
    }
  }, []);

  useEffect(() => {
    if (targetGroup) {
      setTargetMemberId("all");
      getMembersInGroup(targetGroup.id);
    }
  }, [targetGroup]);

  useEffect(() => {
    if (targetGroup && targetPeriod) {
      const year = targetPeriod.slice(0, 4);
      const month = targetPeriod.slice(4, 6);
      const startDate = `${year}-${month}-01-00-00-00`;

      getMeasurement(targetGroup.id, startDate);
    }
  }, [targetPeriod]);

  const [measurements, setMeasurements] = useState();
  const [measurementsLoading, setMeasurementsLoading] = useState(false);
  const [targetMeasurements, setTargetMeasurements] = useState();

  const getMembersInGroup = (groupId) => {
    setMembersLoading(true);
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetMembersInTargetGroup?code=${code}&GroupId=${groupId}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        setGroupMembers(response);
        setMembersLoading(false);
      })
      .catch(() => {
        setGroupMembers([]);
        setMembersLoading(false);
      });
  };

  const getOwnedGroups = (orgUser) => {
    // get organization users data
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL + `/api/GetOwnedGroups?code=${code}&UserId=${orgUser.id}`;
    //console.log(url);
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        //console.log(response);
        setOwnedGroups(response);
      })
      .catch(() => {
        setOwnedGroups([orgUser]);
      });
  };

  const getMeasurement = (groupId, startDate) => {
    setMeasurementsLoading(true);
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/GetMeasurementByGroupAndStartDate?code=${code}&GroupId=${groupId}&StartDate=${startDate}`;
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        setMeasurements(response);
        setMeasurementsLoading(false);
      })
      .catch(() => {
        console.log("no member exists");
        setMeasurementsLoading(false);
      });
  };

  // データテーブルを更新する
  const updateMeasurements = () => {
    const year = targetPeriod.slice(0, 4);
    const month = targetPeriod.slice(4, 6);
    const startDate = `${year}-${month}-01-00-00-00`;

    getMeasurement(targetGroup.id, startDate);
  };

  const deleteSelectedMeasurement = () => {
    if (!targetMeasurements || targetMeasurements.length == 0) {
      errorModalOpen("測定記録削除", "削除するデータを選択してください");
      return;
    }

    let bodyObj = {};
    let measurementsIdAry = [];
    targetMeasurements.forEach((measurement) => {
      measurementsIdAry.push(measurement.id);
    });

    bodyObj.MeasurementIds = measurementsIdAry;
    const bodyString = JSON.stringify(bodyObj);

    const code = process.env.REACT_APP_API_CODE;
    let url = API_DOMAIN_URL + `/api/DeleteMeasurement?code=${code}`;

    fetch(url, {
      method: "POST",
      body: bodyString,
    }).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          successModalOpen("測定記録削除", "選択した測定記録を削除しました");

          updateMeasurements();
        } else if (response.status == 204 || response.status == 400) {
          errorModalOpen("測定記録削除", "測定記録の削除に失敗しました");
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  // 削除確認モーダル
  const [deleteConfirmModalStatus, setDeleteConfirmModalStatus] = React.useState(false);
  const deleteConfirmModalOpen = () => {
    if (!targetMeasurements || targetMeasurements.length == 0) {
      errorModalOpen("測定記録削除", "削除するデータを選択してください");
      return;
    }
    setDeleteConfirmModalStatus(true);
  };
  const deleteConfirmModalClose = () => setDeleteConfirmModalStatus(false);
  const onDeleteConfirmed = () => {
    setDeleteConfirmModalStatus(false);
    deleteSelectedMeasurement();
  };

  // 更新完了確認のモーダル
  const [successModalStatus, setSuccessModalStatus] = React.useState(false);
  const [successTitle, setSuccessTitle] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const successModalOpen = (title, message) => {
    setSuccessTitle(title);
    setSuccessMessage(message);
    setSuccessModalStatus(true);
  };
  const successModalClose = () => {
    setSuccessModalStatus(false);
  };

  // エラーモーダル
  const [errorModalStatus, setErrorModalStatus] = React.useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const errorModalOpen = (title, message) => {
    setErrorTitle(title);
    setErrorMessage(message);
    setErrorModalStatus(true);
  };
  const errorModalClose = () => {
    setErrorModalStatus(false);
  };

  return (
    <div className="asset-list-root">
      <AccountMenu />
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={4}>
              <Typography component="h1" variant="h5">
                測定データ編集
              </Typography>
            </Grid>
            <Grid item md={8}></Grid>

            <Grid item md={4} mt={2}>
              <OwnedGroupSelectBox2
                ownedGroups={ownedGroups}
                setTargetGroup={setTargetGroup}
              />
            </Grid>
            <Grid item md={3} mt={2}>
              <FormControl sx={{ m: 1, width: 200 }} disabled={!targetGroup || membersLoading}>
                <InputLabel id="member-select-label">
                  {membersLoading ? "読み込み中..." : "メンバー"}
                </InputLabel>
                <Select
                  labelId="member-select-label"
                  label="メンバー"
                  value={targetMemberId}
                  onChange={(e) => setTargetMemberId(e.target.value)}
                  size="small"
                >
                  <MenuItem value="all">全員</MenuItem>
                  {groupMembers.map((m, i) => (
                    <MenuItem value={m.id} key={i}>
                      {m.NickName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item md={3} mt={2}>
              <MeasurementStartDateSelectBox
                setTargetPeriod={setTargetPeriod}
              />
            </Grid>
            <Grid item md={3} mt={2}></Grid>
          </Grid>

          <MeasurementDataTable
            measurements={
              measurements && targetMemberId !== "all"
                ? measurements.filter((m) => m.UserId === targetMemberId)
                : measurements
            }
            setTargetMeasurements={setTargetMeasurements}
            loading={measurementsLoading}
          />

          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item md={4}>
              <Button
                variant="contained"
                color="error"
                sx={{ pr: "50px", pl: "50px", m: "20px" }}
                onClick={() => deleteConfirmModalOpen()}
              >
                選択行を削除
              </Button>
            </Grid>
            <Grid item md={4}></Grid>
            <Grid item md={4}></Grid>
          </Grid>
          <Box sx={{ mb: 4 }} />
        </Box>
      </Container>
      <Modal
        title={"測定記録削除"}
        message={`選択した${targetMeasurements ? targetMeasurements.length : 0}件の測定記録を削除しますか？この操作は元に戻せません。`}
        status={deleteConfirmModalStatus}
        okBtnLabel={"削除"}
        okBtnCallback={onDeleteConfirmed}
        cancelBtnCallback={deleteConfirmModalClose}
      />
      <Modal
        title={errorTitle}
        message={errorMessage}
        status={errorModalStatus}
        okBtnCallback={errorModalClose}
      />
      <Modal
        title={successTitle}
        message={successMessage}
        status={successModalStatus}
        okBtnCallback={successModalClose}
      />
    </div>
  );
}
